import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export const Blog = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blogs").then(r => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <div className="rieave-container py-12 md:py-16" data-testid="blog-page">
      <p className="eyebrow mb-2">The journal</p>
      <h1 className="font-hero text-5xl md:text-6xl mb-10">Stories, styled <span className="serif-italic text-rose">slowly.</span></h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map(p => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group" data-testid={`blog-card-${p.slug}`}>
            <div className="rounded-[20px] overflow-hidden aspect-[4/3] bg-blush/40">
              {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
            </div>
            <p className="eyebrow mt-4">{(p.tags || [])[0] || "rieave"}</p>
            <h3 className="font-hero text-2xl mt-1 group-hover:text-rose transition">{p.title}</h3>
            <p className="text-sm text-mauve mt-2 line-clamp-2">{p.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export const BlogDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blogs/${slug}`).then(r => setPost(r.data)).catch(() => {}); }, [slug]);
  if (!post) return <div className="py-20 text-center text-mauve">Loading…</div>;

  return (
    <article className="rieave-container py-12 md:py-16" data-testid="blog-detail-page">
      <Link to="/blog" className="btn-link mb-6">← Back to journal</Link>
      <p className="eyebrow mb-2">{(post.tags || [])[0] || "rieave journal"}</p>
      <h1 className="font-hero text-4xl md:text-6xl max-w-3xl mb-4">{post.title}</h1>
      <p className="font-label text-xs uppercase tracking-[0.22em] text-mauve mb-8">By {post.author} · {new Date(post.created_at).toDateString()}</p>
      {post.cover_image && (
        <div className="rounded-[24px] overflow-hidden aspect-[16/9] mb-10 bg-blush/40">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
      )}
      <div className="prose max-w-3xl font-body text-lg leading-[1.75] text-charcoal/85 whitespace-pre-line">{post.content}</div>
    </article>
  );
};

export default Blog;
